<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem2" />
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem3" />
        <router-link to="/new1" class="nav-link1"> </router-link>
        <router-link to="/new" class="nav-link2"> </router-link>
        <router-link to="/new2" class="nav-link3"> </router-link>
        <router-link to="/new4" class="nav-link4"> </router-link>
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <!-- <img :src="importedImg4" alt="" class="imgItem4" /> -->
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <!-- <img :src="importedImg5" alt="" class="imgItem5" /> -->
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <!-- <img :src="importedImg6" alt="" class="imgItem6" /> -->
      </div>
    </div>
    <!-- <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <img :src="importedImg7" alt="" class="imgItem7" />
      </div>
    </div> -->
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/growmoney/components/img/3_1.png";
import importedImg2 from "@/page/growmoney/components/img/3_3_1.png";
import importedImg3 from "@/page/growmoney/components/img/3_3_2.png";
// import importedImg4 from "@/page/growmoney/components/img/2_4.png";
// import importedImg5 from "@/page/growmoney/components/img/2_5.png";
// import importedImg6 from "@/page/growmoney/components/img/2_6.png";
// import importedImg7 from "@/page/growmoney/components/img/2_7.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      // importedImg4: importedImg4,
      // importedImg5: importedImg5,
      // importedImg6: importedImg6,
      // importedImg7: importedImg7,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0});
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
img {
  display: block;
}
.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}

.img2Box {
  padding: 20px 200px;
}

.img3Box {
  position: relative;
  margin-top: -2px;
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  /* border: 1px solid red; */
  position: absolute;
  cursor: pointer;
}

.nav-link1 {
  top: 20.5%;
  left: 14%;
  width: 15.5%;
  height: 2.5%;
}
.nav-link2 {
  top: 43.8%;
    left: 50.5%;
    width: 10%;
    height: 2.5%;
}
.nav-link3 {
  top: 69%;
    left: 13%;
    width: 11%;
    height: 2.5%;
}
.nav-link4 {
  top: 89.7%;
  width: 10%;
  left: 50.5%;
  height: 2.5%;
}
.nav-link5 {
  top: 46%;
  left: 41.5%;
  width: 18%;
  height: 6%;
}
</style>
